/* 
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.filter('_html',function ($sce) { 
    return function (text) {
        return $sce.trustAsHtml(text);
    };    
});
